<template>
  <main
    id="insuranceAuthorized-page"
    class="insuranceAuthorized"
  >
    <div class="insuranceAuthorized__progress">
      <div class="progress-bar" id="insuranceAuth-progress-bar"></div>
    </div>
    <div class="insuranceAuthorized__content">
      <div class="insuranceAuthorized__icons">
        <div class="icon-circle circle__card">
          <span class="di di-icon-healthInsurance"></span>
        </div>
        <div class="icon-circle circle__check">
          <span class="di di-icon-check"></span>
        </div>
      </div>
      <h1>Pronto, tudo certo com o seu convênio!</h1>
    </div>
  </main>
</template>
<script>

export default {
  name: 'AuthSuccess',
  async created() {
    setTimeout(() => this.routeController(), 5000);
  },
  methods: {
    async routeController() {
      return this.goNextStep('end_flow_success');
    },
  },
};
</script>

<style lang="scss" scoped>
.circle__card {
  background-color: rgba(51, 224, 151, 0.2);
  height: 112px;
  width: 112px;
  .di-icon-healthInsurance:before {
    font-size: 40px;
    color: var(--color-success);
  }
}
.circle__check {
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: var(--color-success);
  border: 4px solid #ffffff;
  height: 39px;
  width: 39px;
  .di-icon-check:before {
    font-size: 14px;
    color: #ffffff;
  }
}

.insuranceAuthorized {
  height: 100%;
  &__content {
    height: 100%;
    display: flex;
    padding-top: 45%;
    flex-direction: column;
    align-items: center;

    h1 {
      width: 80%;
      padding-top: 30px;
    }
  }

  &__icons {
    position: relative;
    height: fit-content;
  }

  &__progress {
    position: absolute;
    width: 100%;
    height: 6px;
    background: rgba(134, 142, 150, 0.3);

    .progress-bar {
      animation: barProgression 5s forwards;
      height: 100%;
      background: var(--color-primary);

      @keyframes barProgression {
        0% {
          width: 0;
        }
        30% {
          width: 0;
        }
        100% {
          width: 100%;
        }
      }
    }
  }
}
</style>
